import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { returnDateOrderDetailsText } from '../../../utils/order-history/card-utils';
import { FeatureSwitches } from '../../../constants/feature-switches';
var ReturnsOrderDetailsDate = function (_a) {
    var fulfillmentGroup = _a.fulfillmentGroup;
    var upsBarcodeEnabled = !!(FeatureSwitches === null || FeatureSwitches === void 0 ? void 0 : FeatureSwitches.enableUPSBarcode);
    var enableReturnProgressDate = !!(FeatureSwitches === null || FeatureSwitches === void 0 ? void 0 : FeatureSwitches.enableReturnProgressDate);
    return (React.createElement(Typography, { variant: "body-base", weight: "bold" }, returnDateOrderDetailsText(fulfillmentGroup, upsBarcodeEnabled, enableReturnProgressDate)));
};
export default ReturnsOrderDetailsDate;
